module.exports = __webpack_public_path__ + "img/newletter-24.4ddf6ad.png";